module.exports = "/resources/assets/prod/3c0f901d9d5cdbb8f53ae9c5cb5da918.svg";